export default [
  {
    path: "/manage/findByPatientId",
    name: "首页",
    icon: "md-speedometer",
    compName: "Dashboard",
    compPath: "/dashboard"
  },
  {
    name: "学生管理",
    path: "/stu",
    icon: "ios-albums",
    children: [
      {
        path: "/schools/page",
        name: "学校管理",
        icon: "ios-paper",
        compName: "School",
        compPath: "/schoolManage/schools"
      },
      {
        path: "/classes/page",
        name: "班级管理",
        icon: "ios-paper",
        compName: "Classes",
        compPath: "/schoolManage/classes"
      },
      {
        path: "/students/page",
        name: "学生管理",
        icon: "ios-paper",
        compName: "Students",
        compPath: "/schoolManage/students"
      },
      {
        path: "/resident/page",
        name: "居民管理",
        icon: "ios-paper",
        compName: "Resident",
        compPath: "/schoolManage/resident"
      },
    ],
  },
  {
    name: "体检前",
    path: "/pre-screening",
    icon: "ios-albums",
    children: [
      {
        path: "/task-info/page",
        name: "体检任务管理",
        icon: "ios-paper",
        compName: "Task",
        compPath: "/preScreening/task"
      },
      {
        path: "/task-detailed/page",
        name: "体检任务名单",
        icon: "ios-paper",
        compName: "TaskDetail",
        compPath: "/preScreening/taskDetail"
      },
    ],
  },
  {
    name: "体检中",
    path: "/screening",
    icon: "ios-albums",
    children: [
      {
        name: "体检单管理",
        path: "/data-info/page",
        icon: "ios-paper",
        compName: "ScreeningDataInfo",
        compPath: "/screening/screeningDataInfo"
      },
      {
        name: "DR单管理",
        path: "/dr-project/page",
        icon: "ios-paper",
        compName: "DrProject",
        compPath: "/screening/drProject"
      },
      /*{
        name: "DR单管理",
        path: "/dr-project",
        icon: "ios-paper",
        children: [
          {
            path: "/dr-project/page",
            name: "DR单管理",
            icon: "ios-paper",
            compName: "DrProject",
            compPath: "/screening/drProject",
          },
        ],
      },*/
      {
        path: "/collection-log/page",
        name: "收表管理",
        icon: "ios-paper",
        compName: "CollectionLog",
        compPath: "/screening/collectionLog"
      },
      /*{
        name: "检验管理",
        path: "/inspectOrder",
        icon: "ios-albums",
        children: [
          {
            path: "/inspect-order/page",
            name: "检验数据管理",
            icon: "ios-paper",
            compName: "InspectOrderPage",
            compPath: "/screening/inspectOrder/inspectOrderPage",
          },
          {
            path: "/send-inspect-log/page",
            name: "推送日志管理",
            icon: "ios-paper",
            compName: "SendInspectLog",
            compPath: "/screening/inspectOrder/sendInspectLog"
          }
        ],
      },*/
    ],
  },
  {
    name: "体检后",
    path: "/post-screening",
    icon: "ios-albums",
    children: [
      {
        path: "/inspect-order/page",
        name: "检验数据管理",
        icon: "ios-paper",
        compName: "InspectOrderPage",
        compPath: "/screening/inspectOrder/inspectOrderPage",
      },
      {
        path: "/send-inspect-log/page",
        name: "检验日志管理",
        icon: "ios-paper",
        compName: "SendInspectLog",
        compPath: "/screening/inspectOrder/sendInspectLog"
      },
      {
        path: "/error-report/pages",
        name: "风险评估",
        icon: "ios-paper",
        compName: "ErrorReport",
        compPath: "/postScreening/errorReport"
      },
    ],
  },
  {
    name: "配置管理",
    path: "/screening-config",
    icon: "ios-albums",
    children: [
      {
        path: "/inspect-organize/page",
        name: "送检机构管理",
        icon: "ios-paper",
        compName: "InspectOrganize",
        compPath: "/screeningConfig/inspectOrganize"
      },
      {
        path: "/lis-project/search",
        name: "检验项目",
        icon: "ios-paper",
        compName: "LisProject",
        compPath: "/screeningConfig/lisProject"
      },
      {
        path: "/field-config/page",
        name: "字段配置",
        icon: "ios-paper",
        compName: "FieldConfig",
        compPath: "/screeningConfig/physicalConfig/fieldConfig",
      },
      {
        path: "/physical-project/search",
        name: "体检项目",
        icon: "ios-paper",
        compName: "PhysicalProject",
        compPath: "/screeningConfig/physicalConfig/physicalProject",
      },
      {
        path: "/physical-packages/page",
        name: "体检套餐",
        icon: "ios-paper",
        compName: "PhysicalPackages",
        compPath: "/screeningConfig/physicalConfig/physicalPackages",
      },
      {
        path: "/required-item-config/getPhysicalFormByPackage",
        name: "套餐模版管理",
        icon: "ios-paper",
        compName: "RequiredManage",
        compPath: "/screeningConfig/physicalConfig/requiredManage",
      },
      {
        path: "/develop-standard-manage/list",
        name: "儿童生长发育标准",
        icon: "ios-paper",
        compName: "DevelopStandardManage",
        compPath: "/screeningConfig/physicalConfig/developStandardManage",
      },
      {
        path: "/error-config/pages",
        name: "异常配置",
        icon: "ios-paper",
        compName: "ErrorConfig",
        compPath: "/screeningConfig/physicalConfig/errorConfig",
      },
      {
        path: "/result-word/pages",
        name: "结果词库管理",
        icon: "ios-paper",
        compName: "ResultWord",
        compPath: "/screeningConfig/physicalConfig/resultWord",
      },
      {
        path: "/referral-institutiont/pages",
        name: "转诊机构",
        icon: "ios-paper",
        compName: "ReferralInstitutiont",
        compPath: "/screeningConfig/physicalConfig/referralInstitutiont",
      },
      {
        path: "/referral-department/pages",
        name: "转诊科室",
        icon: "ios-paper",
        compName: "ReferralDepartment",
        compPath: "/screeningConfig/physicalConfig/referralDepartment",
      },
    ],
  },
  {
    name: "导入导出管理",
    path: "/input-output",
    icon: "ios-albums",
    children: [
      {
        path: "/batch-input-log/page",
        name: "导入记录管理",
        icon: "ios-paper",
        compName: "BatchInputLog",
        compPath: "/inputOutput/batchInputLog"
      },
      {
        path: "/batch-output-log/page",
        name: "导出记录管理",
        icon: "ios-paper",
        compName: "BatchOutputLog",
        compPath: "/inputOutput/batchOutputLog"
      },
    ],
  },
  {
    path: "/his-temporary-login",
    name: "临时登录管理",
    icon: "md-folder-open",
    children: [
      {
        path:"/wechatLoginCode/selectPages",
        name:"登录校验码",
        icon: "ios-list-box",
        compName: "wechatLoginCode",
        compPath: "/temporaryLogin/wechatLoginCode"
      },
    ],
  },
  {
    path: "/sys",
    name: "系统管理",
    icon: "ios-albums",
    children: [
      {
        path: "/sysUser/selectPages",
        name: "用户管理",
        icon: "ios-paper",
        compName: "Users",
        compPath: "/manage/users"
      },
      {
        path: "/sysRole/selectPages",
        name: "角色管理",
        icon: "ios-paper",
        compName: "Roles",
        compPath: "/manage/roles"
      },
      {
        path: "/institution/selectPages",
        name: "机构管理",
        icon: "ios-paper",
        compName: "Institutions",
        compPath: "/manage/institutions"
      }
    ]
  },
];
